import {isSelectedTab} from './../../../utils/commonFunctions'

export default function CustomerClicksComponent({selectedTab}){
  return(
    <>
      <div className={isSelectedTab(selectedTab,'clicks')}>
        Clicks compononet
      </div>
    </>
  )
}